/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { AccountingAccountDialogComponent } from './accounting-account-dialog.component';

export const accountingAccountFinderDialogRoute = createDialogRoute({
  component: AccountingAccountDialogComponent,
});
